import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

export default function ForcedPasswordGate({ children }) {
  const { user } = useUser();

  if (user?.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}